<template>
  <ul class="company-group-filter-list">
    <!--
    <li>TODO: Einträge für gelöschte und "firmenlose" Kampagnen anzeigen
    </li>
    <li>(Datei-Upload bzw. -Wiederherstellung muss auch serverseitig deaktiviert werden)</li>
    <li>
      <hr>
    </li>
    -->

    <template v-if="type === 'companyGroups' || type === 'both'">
      <li class="filter-section-header">CompanyGroups</li>
      <li
        class="filter-item"
        :class="{
          'filter-item-selected': isFilterSelected(
            companyGroup.id,
            'companyGroup'
          ),
        }"
        v-for="companyGroup of type === 'both'
          ? [...companyGroups, { id: -1, name: 'Ungruppierte Firmen' }]
          : companyGroups"
        :key="'group' + companyGroup.id"
        @click="selectCompanyGroup(companyGroup.id)"
      >
        <div class="filter-item-title">{{ companyGroup.name }}</div>
        <div
          class="count-badge count-badge-green"
          title="Companies in der Gruppe"
          v-if="type === 'both'"
        >
          {{
            companyGroup.id === -1
              ? ungroupedCompanies.length
              : getCompaniesForGroup(companyGroup.id).length
          }}
        </div>
        <div
          class="count-badge"
          :class="{
            'count-badge-hidden':
              companyGroup.availablePromotionsCount === undefined,
          }"
          v-if="displayPromoCount"
          title="Verfügbare Promotions"
        >
          {{ companyGroup.availablePromotionsCount }}
        </div>
      </li>
    </template>

    <template v-if="type === 'companies' || type === 'both'">
      <li class="filter-section-header">Companies</li>
      <template v-if="companiesForSelectedGroup !== null || companies !== null">
        <li
          class="filter-item"
          :class="{
            'filter-item-selected': isFilterSelected(company.id, 'company'),
          }"
          v-for="company of type === 'both'
            ? companiesForSelectedGroup
            : companies"
          :key="'comp' + company.id"
          @click="selectCompany(company.id)"
        >
          <div class="filter-item-title">{{ company.name }}</div>
          <div
            class="count-badge"
            title="Verfügbare Promotions"
            v-if="displayPromoCount"
          >
            {{ company.availablePromotionsCount }}
          </div>
        </li>
      </template>
      <template v-else-if="type === 'both'">
        <li class="filter-text-item">Keine CompanyGroup ausgewählt</li>
      </template>
    </template>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FilterCompaniesAndGroups",
  data: function () {
    return {
      /**
       * @type {{type: 'company'|'companyGroup', companyId: number?, companyGroupId?: number}|null}
       */
      selectedFilter: this.initSelectedFilter,
    };
  },
  props: {
    /**
     * @type {'companies'|'companyGroups'|'both'}
     */
    type: String,
    displayPromoCount: {
      type: Boolean,
      default: () => true,
    },
    /**
     * @type {{type: 'company'|'companyGroup', id: number, companyGroupId?: number}|null}
     */
    initSelectedFilter: null,
  },
  computed: {
    ...mapGetters(["companies", "companyGroups"]),
    companiesForSelectedGroup() {
      const selected = this.selectedFilter;
      if (!selected) return null;
      if (selected.id === -1)
        // ungrouped companies
        return this.ungroupedCompanies;
      return this.companies.filter(
        (comp) =>
          comp.companyGroupId === selected.companyGroupId ||
          (selected.type === "companyGroup" &&
            comp.companyGroupId === selected.id)
      );
    },
    ungroupedCompanies() {
      return this.companies.filter((comp) => comp.companyGroupId === null);
    },
  },
  methods: {
    async selectCompanyGroup(id) {
      this.selectedFilter = { id, type: "companyGroup" };
      this.$emit("filter-change", { companyGroupId: id, type: "companyGroup" });
    },
    async selectCompany(id) {
      const companyGroupId = this.companies.find((comp) => comp.id === id)
        .companyGroupId;
      this.selectedFilter = { companyId: id, type: "company", companyGroupId };
      this.$emit("filter-change", { ...this.selectedFilter });
    },

    isFilterSelected(id, type) {
      return (
        !!this.selectedFilter &&
        ((this.type === "both" &&
          type === "companyGroup" &&
          this.selectedFilter.type === "company" &&
          this.selectedFilter.companyGroupId === id) ||
          (type === "company" &&
            this.selectedFilter.type === "company" &&
            this.selectedFilter.companyId === id) ||
          (type === "companyGroup" &&
            this.selectedFilter.type === "companyGroup" &&
            this.selectedFilter.companyGroupId === id))
      );
    },

    getCompaniesForGroup(groupId) {
      return this.companies.filter((comp) => comp.companyGroupId === groupId);
    },
  },
};
</script>

<style scoped>
.company-group-filter-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;

  text-align: left;
  list-style: none;
  background-color: var(--contrast-1);
}

.filter-section-header {
  font-weight: bold;
  margin: 0.25rem 0;
  padding: 0 0.5rem;
}

.filter-text-item {
  padding: 0 0.75rem;
  font-style: italic;
}

.filter-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 0 0.75rem;

  background-color: var(--contrast-2);
  cursor: pointer;
}

.filter-item:hover {
  background-color: var(--contrast-3);
}

.filter-item-selected {
  background-color: var(--contrast-3);
}

.filter-item-title {
  cursor: unset;
  flex-basis: 100%;
  margin: 0.375rem 0;
}

.count-badge {
  flex: 2rem 0 0;
  font-size: 0.75rem;
  margin-left: 0.5rem;
  border-radius: 50%;
  background-color: var(--mp);
  max-width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.count-badge-green {
  background-color: var(--md);
}

.count-badge-hidden {
  visibility: hidden;
}
</style>
